export const availableOnlineType = {
  both: "Both",
  origin: "Origin",
  destination: "Destination",
  not_available: "Not available",
};
